import { ROUND_TRIP } from '../constants'

export const DEFAULT_VALUES = {
  FLIGHT_TYPE: ROUND_TRIP,
  CABIN_CLASS: 'Economy',
  ADD_HOTEL: false,
  ADD_CAR: false,
} as const
